/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../molecules/language-navigation/css/language-navigation';
import '../../../molecules/meta-navigation/css/meta-navigation';
import './footer-navigation.scss';
